// Ayudas comunes de las pantallas con ciclo de vida: secciones del editor, filtros, KPIs y campos
// que todas comparten. Lo propio de cada dominio vive en su diccionario.

export const LIFECYCLE_SECTION_HELP = {
    description:
        'Cómo se llama y cómo se le explica a quien la usa. Solo informa, no cambia lo que se paga.',
    levers: 'Lo que recibe quien cumple: descuentos, bonos o premios. Llena una o varias.',
    audience:
        'Qué clientes o vendedores pueden recibirla. Con «Todos» en cada columna aplica a todos.',
    scope: 'En qué productos y tiendas aplica. Sin nada elegido en una columna aplica a todo.',
    whenPaid: 'El evento que tiene que pasar para que se pague.',
    rules: 'Condiciones extra que limitan cuándo y cuántas veces aplica.',
    budget: 'Cuánto dinero se puede gastar como máximo. Al agotarse se pausa sola.',
    validity: 'Desde y hasta cuándo aplica. Permanente no tiene fecha de fin.',
} as const;

export const LIFECYCLE_FIELD_HELP = {
    name: 'El nombre con el que la reconoces en la lista y en los reportes.',
    description: 'El texto con el que se le explica el beneficio a quien lo recibe.',
    budgetMax: 'Tope de dinero en pesos. Vacío no tiene tope.',
} as const;

export const LIFECYCLE_LIST_HELP = {
    search: 'Busca por nombre, sin importar mayúsculas ni acentos.',
    status: 'Muestra solo las que están en ese estado.',
} as const;

export const LIFECYCLE_KPI_HELP = {
    active: 'Las que aplican hoy.',
    scheduled: 'Publicadas que todavía no empiezan su vigencia.',
    paused: 'Detenidas a mano o por presupuesto; puedes reanudarlas o vencerlas.',
    draft: 'Guardadas sin publicar: todavía no aplican.',
} as const;
